import dayjs from 'dayjs';

/**
 * File name of a printed account report ("Save as PDF" takes it from the page title):
 * `Name_accountID_year` for a yearly report, `Name_accountID_year_monthName` for a monthly one
 * (e.g. `William_Ferner_UD00368921_2026_September`). Spaces of the owner name become `_`,
 * characters a file name cannot hold are dropped.
 */
const reportFileName = ({
  name,
  accountId,
  start,
  type,
}: {
  readonly name: string;
  readonly accountId: string;
  readonly start: string;
  readonly type: string;
}): string => {
  const owner = name
    .replace(/[\\/:*?"<>|]/g, '')
    .trim()
    .replace(/\s+/g, '_');
  const date = dayjs(start);
  const period = type === 'yearly' ? date.format('YYYY') : `${date.format('YYYY')}_${date.locale('en').format('MMMM')}`;

  return [owner, accountId.toUpperCase(), period].filter(Boolean).join('_');
};

export { reportFileName };
